import React from "react";
import SearchFormTimeSlots from "./search_form_time_slots";

const SearchFormSort = ({
  sortEventKeys,
  sortEventFunc,
  eventCondition = "",
  timeSlot,
  onChangeTimeSlot,
}) => {

  return (
    <div className="search-event__narrow-btn d-flex align-items-start flex-wrap">
      <div className="d-flex mr-3 mb-2">
        <button
          className={`btn btn-sm rounded-pill ${
            !eventCondition ? "btn-secondary" : "btn-outline-secondary"
          } px-3 mr-2`}
          style={{ fontSize: "0.8rem" }}
          value={sortEventKeys.poplular}
          onClick={(e) => sortEventFunc(e.target.value)}
        >
          人気順
        </button>
        <button
          className={`text-fz-14px btn btn-sm rounded-pill ${
            eventCondition == sortEventKeys.recently
              ? "btn-secondary"
              : "btn-outline-secondary"
          } px-3 mr-2`}
          style={{ fontSize: "0.8rem" }}
          value={sortEventKeys.recently}
          onClick={(e) => sortEventFunc(e.target.value)}
        >
          開催順
        </button>
        <button
          className={`btn btn-sm rounded-pill ${
            eventCondition == sortEventKeys.new
              ? "btn-secondary"
              : "btn-outline-secondary"
          } px-3 mr-2`}
          style={{ fontSize: "0.8rem" }}
          value={sortEventKeys.new}
          onClick={(e) => sortEventFunc(e.target.value)}
        >
          新着
        </button>
      </div>
      <div className="mb-2">
        <div className="d-flex flex-wrap align-items-center">
          <SearchFormTimeSlots
            timeSlot={timeSlot}
            onChangeTimeSlot={onChangeTimeSlot}
          />
        </div>
        <p className="mt-1 mb-0" style={{ fontSize: "0.65rem", color: "#aaa" }}>
          朝 4:00〜10:59 / 昼 11:00〜16:59 / 夜 17:00〜3:59
        </p>
      </div>
    </div>
  );
};

export default SearchFormSort;
